import checkAccess from "./checkAccess";

const users = JSON.parse(localStorage.getItem("bigfoot-admin"));

let isAdmin = false;
let hasDataManagement = false;

let dataManageArray = [
  "country",
  "report_category",
  "colors",
  "language",
  "security_question",
  "reject_reason",
  "timezone",
];

if (users && typeof users === "object") {
  const useArray = Object.values(users);
  const adminUser = useArray?.find((user) => user?.role === "Admin");

  if (adminUser) {
    isAdmin = true;
  }
} else if (users?.role === "Admin") {
  isAdmin = true;
}

dataManageArray.forEach((item) => {
  if (checkAccess(`read_${item}`)) {
    hasDataManagement = true;
  }
});

export const MENU_SIDEBAR = [
  { title: "Dashboard", path: "/dashboard", id: "skip" },
  { title: "Users", path: "/users", action: "read", id: "users" },
  // { title: "Announcement", path: "/announcement", action: "read", id: "announcement" },
  { title: "Reviews", path: "/reviews", action: "read", id: "review" },
  ...(hasDataManagement
    ? [
        {
          title: "Data Management",
          children: [
            {
              title: "Countries",
              path: "/data-management/country",
              action: "read",
              id: "country",
            },
            {
              title: "Report Categories",
              path: "/data-management/report-category",
              action: "read",
              id: "report_category",
            },
            {
              title: "Label & Folder Colors",
              path: "/data-management/color",
              action: "read",
              id: "colors",
            },
            {
              title: "Language",
              path: "/data-management/language",
              action: "read",
              id: "language",
            },
            // {
            //   title: "Security Questions",
            //   path: "/data-management/security-question",
            //   action: "read",
            //   id: "security_question",
            // },
            {
              title: "Reject Reason",
              children: [
                {
                  title: "Delete Account Reasons",
                  path: "/data-management/delete-account/deleteAccount",
                  action: "read",
                  id: "reject_reason",
                },
                {
                  title: "Report Phishing Reasons",
                  path: "/data-management/report-phishing/reportMail",
                  action: "read",
                  id: "phishing_reason",
                },
                {
                  title: "Report Chat Reason",
                  path: "/data-management/report-chat/reportChat",
                  action: "read",
                  id: "report_chat",
                },
              ],
            },
            {
              title: "User Plan",
              path: "/data-management/user-plan",
              action: "read",
              id: "user_plan",
            },
            {
              title: "Holiday",
              path: "/data-management/holiday",
              action: "read",
              id: "holiday",
            },
            // {
            //   title: "Default Preferences",
            //   path: "/data-management/defaultPreferences",
            //   action: "read",
            //   id: "dSetting",
            // },
            {
              title: "Signature",
              path: "/data-management/signature",
              action: "read",
              id: "signature",
            },
            {
              title: "TimeZone",
              path: "/data-management/timezone",
              action: "read",
              id: "timezone",
            },
            {
              title: "Help And Feedback",
              path: "/data-management/help-and-feedback",
              action: "read",
              id: "help_and_feedback",
            },
            {
              title: "Emoji",
              path: "/data-management/emoji",
              action: "read",
              id: "emoji",
            },
            //  {
            //   title: "Get the Apps",
            //   path: "/data-management/get-the-app",
            //   action: "read",
            //   id: "get-the-app",
            // },
          ],
          action: "read",
          id: "skip",
        },
      ]
    : []),
  ...(isAdmin
    ? [
        {
          title: "Members & Roles",
          children: [
            {
              title: "Roles",
              path: "/access-management/roles",
              action: "read",
              id: "roles",
            },
            {
              title: "Permissions",
              path: "/access-management/permission",
              action: "read",
              id: "permission",
            },
            {
              title: "Team Members",
              path: "/access-management/team-members",
              action: "read",
              id: "team_member",
            },
          ],
          action: "read",
          id: "roles",
        },
      ]
    : []),
  {
    title: "Report Categories",
    children: [
      ...(checkAccess("read_report_chat_user")
        ? [
            {
              title: "Reported Chats",
              path: "/report/chat",
              action: "read",
              id: "report_chat_user",
            },
          ]
        : []),

      ...(checkAccess("read_report_problem")
        ? [
            {
              title: "Report Problem Mail",
              path: "/report/problem",
              action: "read",
              id: "report_problem",
            },
          ]
        : []),
    ],
    action: "read",
    id: "report",
  },
];
